/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerFindOneQueryResponse, ProjectTypesControllerFindOnePathParams, ProjectTypesControllerFindOneQueryParams, ProjectTypesControllerFindOne400, ProjectTypesControllerFindOne401, ProjectTypesControllerFindOne403, ProjectTypesControllerFindOne404 } from "../../models/projectTypesController/ProjectTypesControllerFindOne";

function getProjectTypesControllerFindOneUrl(id: ProjectTypesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/project-types/${id}` as const }  
  return res
}

/**
 * @summary Get a project type by ID
 * {@link /api/v1/project-types/:id}
 */
export async function projectTypesControllerFindOne(id: ProjectTypesControllerFindOnePathParams["id"], params?: ProjectTypesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectTypesControllerFindOneQueryResponse, ResponseErrorConfig<ProjectTypesControllerFindOne400 | ProjectTypesControllerFindOne401 | ProjectTypesControllerFindOne403 | ProjectTypesControllerFindOne404>, unknown>({ method : "GET", url : getProjectTypesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}